export const ENDPOINT = '/ws-favorites/favorites/v1/favorites'
